const sanitizeGroupItems = (items) => {
  const seen = new Set();

  return items
    .map((item) => (typeof item === 'string' ? item.trim() : item))
    .filter((item) => item !== null && item !== undefined && item !== '')
    .filter((item) => {
      const signature = typeof item === 'string' ? item : JSON.stringify(item);
      if (seen.has(signature)) {
        return false;
      }
      seen.add(signature);
      return true;
    })
    .sort((a, b) => String(a).localeCompare(String(b)));
};

export const normalizeGroupValue = (value) => {
  if (value === null || value === undefined || value === '' || value === 'null') {
    return [];
  }

  if (Array.isArray(value)) {
    return sanitizeGroupItems(value);
  }

  if (typeof value === 'string') {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return sanitizeGroupItems(parsed);
      }
      if (parsed) {
        return sanitizeGroupItems([parsed]);
      }
    } catch (error) {
      return sanitizeGroupItems(
        value
          .split(',')
          .map((item) => item.trim())
          .filter((item) => item.length > 0)
      );
    }
  }

  return sanitizeGroupItems([value]);
};

export const serializeGroupValue = (value) =>
  JSON.stringify(normalizeGroupValue(value));

export const formatGroupListForApi = (value) =>
  normalizeGroupValue(value).join(',');
